import type { TweetResponseReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './tweetResponseReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type TweetResponseReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: TweetResponseReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
